export const permissionTypeConst = {
  ADD: "write",
  READ: "read",
  EDIT: "edit",
  DELETE: "delete",
  LIST: "list"
}
